export const MEMBER_DISPLAY_NAME_MAX_LENGTH = 80;
export const TEAM_INVITE_BATCH_MAX = 10;
export const TEAM_INVITE_ROLES = ["ADMIN", "AGENT"];
/** Effective name shown inside one organization. */
export function resolveMemberDisplayName(memberDisplayName, userDisplayName) {
    const custom = memberDisplayName?.trim();
    if (custom)
        return custom;
    return userDisplayName.trim();
}
export function normalizeInvitationEmail(email) {
    return email.trim().toLowerCase();
}
export function canAccessTeam(role) {
    return role === "OWNER" || role === "ADMIN";
}
export function isInboxOnlyRole(role) {
    return role === "AGENT";
}
/** AGENT may stay on Inbox. Every other workspace route is forbidden. */
export function isAgentAllowedPath(pathname) {
    return pathname === "/inbox" || pathname.startsWith("/inbox/");
}
/** Roles offered in the Team invite UI while Agent is hidden from product selectors. */
export const VISIBLE_INVITE_ROLES = ["ADMIN"];
export function inviteRolesForActor(actor) {
    if (actor === "OWNER")
        return ["ADMIN", "AGENT"];
    if (actor === "ADMIN")
        return ["AGENT"];
    return [];
}
export function canInviteRole(actor, invited) {
    if (invited !== "ADMIN" && invited !== "AGENT")
        return false;
    return inviteRolesForActor(actor).includes(invited);
}
export function canManageInvitation(actor, invited) {
    return canInviteRole(actor, invited);
}
/** Role the actor may assign, when it would actually change the target. */
export function changeableRole(actor, target) {
    if (actor === "OWNER" && target === "ADMIN")
        return "AGENT";
    if (actor === "OWNER" && target === "AGENT")
        return "ADMIN";
    return null;
}
export function canAssignMemberRole(actor, target, next) {
    if (target === "OWNER" || next === "OWNER")
        return false;
    if (actor === "OWNER") {
        return ((target === "ADMIN" || target === "AGENT") &&
            (next === "ADMIN" || next === "AGENT"));
    }
    return false;
}
/** Who may edit an organization-scoped member name from Team. */
export function canEditMemberDisplayName(actor, target, isSelf) {
    if (isSelf)
        return actor === "OWNER" || actor === "ADMIN";
    if (actor === "OWNER")
        return target === "ADMIN" || target === "AGENT" || target === "OWNER";
    if (actor === "ADMIN")
        return target === "AGENT";
    return false;
}
export function canRemoveMember(actor, target) {
    if (target === "OWNER")
        return false;
    if (actor === "OWNER")
        return target === "ADMIN" || target === "AGENT";
    if (actor === "ADMIN")
        return target === "AGENT";
    return false;
}
export function railDestinations(role) {
    if (role === "AGENT")
        return ["/inbox"];
    return ["/inbox", "/contacts", "/campaigns", "/reports", "/channels", "/settings"];
}
//# sourceMappingURL=team-access.js.map